/**
 * Custom hook to show interstitial ads when screen comes into focus
 * Respects 5-minute rate limit and only shows for non-subscribers
 */

import React from 'react';
import { useFocusEffect } from '@react-navigation/native';
import { useSubscription } from '../context/SubscriptionContext';
import { adService } from '../services/adService';

/**
 * Hook to show interstitial ad when screen comes into focus
 * Only shows for non-subscribers with 5-minute rate limiting
 */
export const useInterstitialAd = () => {
  const { shouldShowAds } = useSubscription();

  useFocusEffect(
    React.useCallback(() => {
      const shouldShow = shouldShowAds();
      console.log('AdMob: Screen focused, shouldShowAds:', shouldShow);
      
      if (shouldShow) {
        // Delay to ensure smooth screen transition
        const timer = setTimeout(() => {
          console.log('AdMob: Attempting to show interstitial ad');
          adService.showInterstitialAd()
            .then((shown) => {
              console.log('AdMob: Interstitial ad show result:', shown);
            })
            .catch((error) => {
              console.error('AdMob: Error showing interstitial ad', error);
            });
        }, 500);

        return () => clearTimeout(timer);
      } else {
        console.log('AdMob: Skipping interstitial ad (user is subscriber)');
      }
    }, [shouldShowAds])
  );
};

